import { Link } from 'react-router-dom';

const cities = [
  { name: 'Baltimore', slug: 'baltimore', county: 'Baltimore City' },
  { name: 'Annapolis', slug: 'annapolis', county: 'Anne Arundel Co.' },
  { name: 'Columbia', slug: 'columbia', county: 'Howard Co.' },
  { name: 'Silver Spring', slug: 'silver-spring', county: 'Montgomery Co.' },
  { name: 'Rockville', slug: 'rockville', county: 'Montgomery Co.' },
  { name: 'Bethesda', slug: 'locations', county: 'Montgomery Co.' },
  { name: 'Gaithersburg', slug: 'locations', county: 'Montgomery Co.' },
  { name: 'Frederick', slug: 'locations', county: 'Frederick Co.' },
  { name: 'Bowie', slug: 'locations', county: 'Prince George\'s Co.' },
  { name: 'Ellicott City', slug: 'locations', county: 'Howard Co.' },
  { name: 'Towson', slug: 'locations', county: 'Baltimore Co.' },
  { name: 'Owings Mills', slug: 'locations', county: 'Baltimore Co.' },
];

const serviceAreaMatrix = [
  { service: 'Installation', slug: 'services', icon: 'ri-home-3-line' },
  { service: 'Refinishing', slug: 'services', icon: 'ri-paint-brush-line' },
  { service: 'Repair', slug: 'services', icon: 'ri-hammer-line' },
  { service: 'Replacement', slug: 'services', icon: 'ri-layout-grid-line' },
];

interface ServiceAreasProps {
  onEstimateClick: () => void;
}

export default function ServiceAreas({ onEstimateClick }: ServiceAreasProps) {
  return (
    <section className="bg-white py-28 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="font-sans text-xs uppercase tracking-widest text-oak font-semibold">Where We Work</span>
          <h2 className="font-serif text-4xl md:text-5xl text-walnut font-bold mt-3 leading-tight">
            Serving Maryland Homeowners
          </h2>
          <p className="font-sans text-charcoal/55 mt-5 text-base max-w-xl mx-auto">
            From Baltimore to the DC suburbs — expert hardwood flooring services across every major Maryland community.
          </p>
        </div>

        {/* Map — Prominent */}
        <div className="rounded-2xl overflow-hidden border-2 border-sand-dark mb-12" style={{ height: '480px' }}>
          <iframe
            title="Premier Hardwood Floors — Maryland"
            src="https://maps.google.com/maps?cid=1080301831309611551&output=embed&hl=en-US"
            width="100%"
            height="480"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
          />
        </div>

        {/* City Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 mb-12">
          {cities.map((city) => (
            <Link
              key={city.name}
              to={`/locations/${city.slug}`}
              className="bg-sand border border-sand-dark rounded-xl p-4 text-center hover:bg-gold/5 hover:border-gold/40 transition-all cursor-pointer group"
            >
              <div className="w-8 h-8 flex items-center justify-center bg-walnut/10 rounded-lg mx-auto mb-2 group-hover:bg-walnut/20 transition-colors">
                <i className="ri-map-pin-2-line text-oak text-sm" />
              </div>
              <div className="font-sans text-sm font-bold text-walnut group-hover:text-oak transition-colors">{city.name}</div>
              <div className="font-sans text-xs text-charcoal/45 mt-0.5">{city.county}</div>
            </Link>
          ))}
        </div>

        {/* Service Area Matrix */}
        <div className="bg-sand rounded-2xl p-8 mb-10 border border-sand-dark">
          <h3 className="font-serif text-xl text-walnut font-bold mb-6 text-center">Services Available Throughout Maryland</h3>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            {serviceAreaMatrix.map((item) => (
              <Link
                key={item.service}
                to={`/${item.slug}`}
                className="flex items-center gap-3 bg-white rounded-xl px-5 py-4 border border-sand-dark hover:border-oak/30 hover:bg-white transition-all group cursor-pointer"
              >
                <div className="w-9 h-9 flex items-center justify-center bg-gold/10 rounded-lg group-hover:bg-gold/20 transition-colors flex-shrink-0">
                  <i className={`${item.icon} text-gold text-base`} />
                </div>
                <span className="font-sans text-sm font-semibold text-walnut group-hover:text-oak transition-colors">{item.service}</span>
                <i className="ri-arrow-right-line text-oak text-xs ml-auto group-hover:translate-x-1 transition-transform" />
              </Link>
            ))}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/locations"
            className="px-8 py-3.5 bg-walnut text-white rounded-xl font-sans text-sm font-bold hover:bg-walnut-dark transition-colors whitespace-nowrap flex items-center justify-center gap-2"
          >
            View All Service Areas <i className="ri-arrow-right-line" />
          </Link>
          <button
            onClick={onEstimateClick}
            className="px-8 py-3.5 border-2 border-walnut text-walnut rounded-xl font-sans text-sm font-semibold hover:bg-sand transition-colors whitespace-nowrap"
          >
            Request Estimate for My Area
          </button>
        </div>
      </div>
    </section>
  );
}
